// extracted by mini-css-extract-plugin
export default {"title":"H7-z","warning":"I7-z","sizeOptionsLegendText":"J7-z"};